import type { FunctionComponent } from 'react';

export const EmptyCircleIcon: FunctionComponent = () => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="6.5" stroke="var(--semantic-text-disabled)" />
        </svg>
    );
};
